const BrandingWidget = {
    RD_DOM: 1,
    RD_Invitation: 2,
    RD_EP: 3,
    RD_PreChat: 4
};
export default BrandingWidget;
